import {
  Button as MuiButton,
  buttonClasses,
  ButtonBase as MuiButtonBase,
  type ButtonBaseProps as MuiButtonBaseProps,
  ButtonGroup as MuiButtonGroup,
  type ButtonGroupProps as MuiButtonGroupProps,
  type ButtonProps as MuiButtonProps,
} from "@mui/material";

export type ButtonProps = MuiButtonProps;
export type ButtonBaseProps = MuiButtonBaseProps;
export type ButtonGroupProps = MuiButtonGroupProps;

export const Button = MuiButton;
export const ButtonBase = MuiButtonBase;
export const ButtonGroup = MuiButtonGroup;
export { buttonClasses };
